<template>
  <tr v-if="phoneExistsInContactPhoneNumber" class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ contactRequest.full_name }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ number }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ status }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ deliveryStatus }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <BaseButton
        v-if="!isSent"
        success
        small
        :disabled="disableSend"
        @click="handleSendSmsMessage"
      >
        Send
      </BaseButton>
    </td>
  </tr>
  <tr v-else class="even:bg-white odd:bg-gray-50">
    <td colspan="5" class="px-4 py-4 text-sm text-red-600">
      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/exclamation -->
            <svg
              class="h-5 w-5 text-yellow-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-yellow-700">
              No valid mobile contact phone matched with phone provided by
              <strong>{{ contactRequest.full_name }}</strong> contact request.
            </p>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { capitalize } from 'lodash-es';

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
    smsMessage: {
      type: Object,
      required: true,
    },
    onSendSmsMessage: {
      type: Function,
      required: true,
    },
    disableSend: Boolean,
  },
  computed: {
    trackingLogs() {
      return this.contactRequest?.sms_message_tracking_logs || [];
    },
    currentSmsMessageTrackingLog() {
      if (!this.smsMessage) {
        return null;
      }

      return (
        this.trackingLogs.find(
          (trackingLog) => trackingLog.sms_message_id === this.smsMessage.id
        ) || null
      );
    },
    status() {
      const { status = '' } = this.currentSmsMessageTrackingLog || {};

      return status ? capitalize(status) : '';
    },
    number() {
      const { msisdn = '' } = this.currentSmsMessageTrackingLog?.delivery_receipt?.[0] || {};

      if (msisdn) {
        return msisdn;
      }

      const { to = '' } = this.currentSmsMessageTrackingLog?.send_response?.messages?.[0] || {};

      return to || '';
    },
    phoneExistsInContactPhoneNumber() {
      const contactRequestPhone = this.contactRequest.phone.replace(/\D/g, '');
      return (this.contactRequest?.contact_phone_numbers || [])
        .filter((phoneNumber) => phoneNumber.number_type === 'mobile')
        .map((phoneNumber) => phoneNumber.number)
        .some((phoneNumber) => phoneNumber.endsWith(contactRequestPhone));
    },
    deliveryStatus() {
      const statuses = (this.currentSmsMessageTrackingLog?.delivery_receipt || [])
        .map((receipt) => capitalize(receipt.status))
        .join(', ');

      return statuses || '';
    },
    isSent() {
      return this.currentSmsMessageTrackingLog !== null;
    },
  },
  methods: {
    handleSendSmsMessage() {
      this.onSendSmsMessage({ contact_request_ids: [this.contactRequest.id] });
    },
  },
};
</script>
